exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-disc[data-v-a3a6d2ce]{list-style:disc}.btn.scale[data-v-a3a6d2ce]:hover{transform:scale(.95)}.btn[data-v-a3a6d2ce]:hover{filter:contrast(.8)}.opacity-50[data-v-a3a6d2ce]{opacity:.5}", ""]);

// exports
